import { FC } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import { Background, NoDataInfo, Sidebar } from '@/components';
import HouseImage from '@/assets/images/image-house.webp';
import strings from '@/language/Swedish';

const PageContainer = styled.div`
  ${tw`flex h-screen`};
`;

const Page = styled.main`
  ${tw`relative flex flex-col flex-1 overflow-y-auto sm:p-4 sm:gap-4`}
`;

const NotFound: FC = () => {
  return (
    <PageContainer>
      <Background />
      <Sidebar defaultFolded={true} />
      <Page>
        <NoDataInfo
          heading={strings.error.notFoundHeader}
          altText={strings.error.notFoundHeader}
          text={strings.error.notFoundDetails}
          img={HouseImage}
        />
      </Page>
    </PageContainer>
  );
};

export default NotFound;
